import type { DocumentCaptureStepValues } from '../constants';

import { useTranslation } from 'react-i18next';
import { default as styled } from 'styled-components';

import { DocumentCaptureStep } from '../constants';

import { documentInstruction } from '@/styles/helpers';

const InstructionSC = styled.h2`
  ${documentInstruction};
`;

export type InstructionProps = {
  captureStep: DocumentCaptureStepValues;
};

export const Instruction = ({ captureStep }: InstructionProps) => {
  const { t } = useTranslation();

  function getInstruction() {
    if (captureStep === DocumentCaptureStep.FRONT_PAGE) {
      return t('steps.documentCapture.frontSide');
    }

    if (captureStep === DocumentCaptureStep.BACK_PAGE) {
      return t('steps.documentCapture.backSide');
    }

    return null;
  }

  return <InstructionSC>{getInstruction()}</InstructionSC>;
};
